import { render } from "./ShareButtons.vue?vue&type=template&id=0ea77f3c&scoped=true"
import script from "./ShareButtons.vue?vue&type=script&lang=js"
export * from "./ShareButtons.vue?vue&type=script&lang=js"

import "./ShareButtons.vue?vue&type=style&index=0&id=0ea77f3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ea77f3c"]])

export default __exports__